import { setupApi } from '@/api/config-setup'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'

async function updateDecoder(interfaceId: number): Promise<void> {
  await setupApi.getDiscoverData(interfaceId)
}

function useDiscoverDataDecoder() {
  const queryClient = useQueryClient()

  return useMutation((payload: any) => updateDecoder(payload.interfaceId), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.controller])
      toast.success('Discover Data Success')
    },
    onError: (error: AxiosError<any>) => {
      toast.error(error?.response?.data?.Message)
    },
  })
}

export default useDiscoverDataDecoder
